// 🤖⚡ MECHA-POG'ZILLA — rival-lab kaiju sighting. Tap to install NEUROLINK CHIPS;
// at 100 chips his CENTRAL COMMAND locks to THE CORE and tappers mint the Legendary POG.
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MechaBoss = () => {
  const [st, setSt] = useState(null);
  const [hidden, setHidden] = useState(false);
  const busy = useRef(false);

  useEffect(() => {
    let alive = true;
    const poll = () => axios.get(`${API}/mecha/status`, { withCredentials: true })
      .then((r) => {
        if (!alive) return;
        setSt(r.data);
        // 📣 REBIRTH BROADCAST — every online POG'R hears it once per rebirth
        if (r.data.reborn_sid) {
          const k = `airpog_rebirth_seen_${r.data.reborn_sid}`;
          if (!localStorage.getItem(k)) {
            localStorage.setItem(k, "1");
            toast.success("🤖⚡ MECHA-POG'ZILLA HAS BEEN REBORN! His CENTRAL COMMAND is THE CORE — the GUARDIANS are on patrol NOW!", { duration: 10000 });
          }
        }
      }).catch(() => {});
    poll();
    const t = setInterval(poll, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!st) return null;
  const showCard = st.active && !hidden;
  const reborn = !!st.reborn;
  const pct = Math.min(100, Math.round(((st.chips || 0) / (st.goal || 100)) * 100));

  const tap = async () => {
    if (busy.current) return;
    busy.current = true;
    try {
      const { data } = await axios.post(`${API}/mecha/tap`, {}, { withCredentials: true });
      if (data.ok) {
        setSt((s) => ({ ...s, chips: data.chips, my_chips: data.my_chips, reborn: data.reborn }));
        if (data.pog) toast.success("🤖⚡ LEGENDARY MECHA-POG'ZILLA MINTED! His CENTRAL COMMAND is THE CORE — check your POGZ collection!", { duration: 9000 });
        else if (data.reborn) toast.success("⚡ MECHA-POG'ZILLA REBORN — POG'ZILLA IS UNSTOPPABLE!", { duration: 7000 });
        else toast.success(`🔩 NEUROLINK CHIP ${data.my_chips}/${st.tap_cap || 10} installed — +${data.bucks} POG BUCKS! THE CORE feeds!`);
      } else if (data.reason) { toast(data.reason); if (data.reborn) setSt((s) => ({ ...s, reborn: true })); }
    } catch {
      toast("Sign in to install NEUROLINK CHIPS! 🧪");
    }
    busy.current = false;
  };

  return (
    <>
      {st.cameo && (
        <div data-testid="mecha-cameo" className="pointer-events-none absolute inset-x-0 bottom-40 z-[1140] overflow-hidden h-24">
          <style>{"@keyframes guardianMarch{0%{transform:translateX(-32vw)}100%{transform:translateX(106vw)}}@keyframes guardianStomp{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}"}</style>
          <div className="absolute bottom-0 flex items-end gap-1" style={{ animation: "guardianMarch 40s linear infinite" }}>
            <img src="/airpogs/pogzilla.webp" alt="POGZILLA on patrol" className="w-16 h-16 drop-shadow-[0_0_14px_rgba(74,222,128,0.85)]" style={{ animation: "guardianStomp 1.1s ease-in-out infinite" }} />
            <img src="/airpogs/mechapogzilla.webp" alt="Reborn MECHA-POG'ZILLA on patrol" className="w-16 h-16 drop-shadow-[0_0_14px_rgba(251,191,36,0.9)]" style={{ animation: "guardianStomp 1.1s ease-in-out 0.55s infinite" }} />
            <span className="mb-1 ml-1 rounded-full px-2 py-0.5 text-[8px] font-heading font-black text-amber-300 border border-amber-400/60" style={{ background: "rgba(20,14,4,0.75)" }}>⚡ GUARDIANS ON PATROL</span>
          </div>
        </div>
      )}
      <AnimatePresence>
      {showCard && (
      <motion.div
        key="sighting"
        data-testid="mecha-boss-overlay"
        initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 40 }}
        className={`absolute bottom-24 left-1/2 -translate-x-1/2 z-[1150] w-[min(92vw,340px)] rounded-2xl border-2 p-2.5 backdrop-blur-md shadow-2xl ${reborn ? "border-amber-400/80 shadow-[0_0_28px_rgba(251,191,36,0.45)]" : "border-red-500/80 shadow-[0_0_28px_rgba(248,113,113,0.4)]"}`}
        style={{ background: "rgba(10,10,18,0.88)" }}
      >
        <button data-testid="mecha-dismiss" onClick={() => setHidden(true)}
          className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-slate-800 border border-white/25 text-white text-[11px] font-black">✕</button>
        <div className="flex items-center gap-2.5">
          <motion.img
            src="/airpogs/mechapogzilla.webp" alt="MECHA-POG'ZILLA"
            animate={{ y: [0, -5, 0], rotate: [0, -2, 2, 0] }} transition={{ duration: 2.2, repeat: Infinity }}
            className={`w-16 h-16 shrink-0 ${reborn ? "drop-shadow-[0_0_16px_rgba(251,191,36,0.9)]" : "drop-shadow-[0_0_16px_rgba(248,113,113,0.9)]"}`}
          />
          <div className="min-w-0 flex-1">
            <p className={`text-[11px] font-heading font-black tracking-wide ${reborn ? "text-amber-300" : "text-red-400 animate-pulse"}`}>
              {reborn ? "⚡ MECHA-POG'ZILLA REBORN!" : "🚨 MECHA-POG'ZILLA SIGHTED!"}
            </p>
            <p className="text-[9px] font-bold text-slate-300 leading-tight">
              {reborn
                ? "CENTRAL COMMAND: THE CORE. POG'ZILLA IS UNSTOPPABLE. 🤖🐲"
                : "The rival lab's kaiju fires a corrupted POG'BEAM! Install NEUROLINK CHIPS to bind him to THE CORE!"}
            </p>
            <div className="mt-1.5 h-2 rounded-full bg-slate-800 overflow-hidden border border-white/10" data-testid="mecha-progress">
              <div className={`h-full rounded-full transition-[width] duration-500 ${reborn ? "bg-gradient-to-r from-amber-400 to-yellow-300" : "bg-gradient-to-r from-red-500 to-orange-400"}`} style={{ width: `${pct}%` }} />
            </div>
            <p className="text-[8px] font-black text-slate-400 mt-0.5">🔩 {st.chips}/{st.goal} NEUROLINK CHIPS · yours: {st.my_chips || 0}/{st.tap_cap || 10}</p>
          </div>
        </div>
        {!reborn && (
          <button data-testid="mecha-tap-btn" onClick={tap}
            className="mt-2 w-full h-10 rounded-full bg-gradient-to-r from-red-500 to-orange-500 text-white font-heading font-black text-[12px] tracking-wider active:scale-95 transition-transform shadow-lg">
            ⚡ TAP — INSTALL NEUROLINK CHIP (+2 POG BUCKS)
          </button>
        )}
      </motion.div>
      )}
      </AnimatePresence>
    </>
  );
};
